<template>
  <div class="ppi-application-container">
    <section class="orep-header mont" v-if="['group-appraiser-representation'].indexOf($route.name) < 0">
      <section class="orep-badge text-uppercase">
        Insurance for Savvy Professionals
      </section>
      <section class="logo-wrapper">
        <img v-if="getApplicantType === 'Mercer' "  src="../../../public/assets/images/mercer-logo.png" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'Realshield'"  src="../../../public/assets/images/realshield-logo-blue.png" class="logo" alt="Logo">
        <img v-else-if="getApplicantType === 'Ermunro'"  src="../../../public/assets/images/ermunro.png" class="logo-ermunro" alt="Logo">
        <img v-else  src="../../../public/assets/images/OREPInsuranceShield_new.png" class="logo" alt="Logo">
        <span v-if="getApplicantType === 'OREP' " class="logo-text text-uppercase">CALIF. LIC. #0K99465</span>
      </section>
    </section>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "ppi-application",
    computed: {
      ppiApplication() {
        return this.$store.state.ppiApplication.ppiApplication;
      },
      state() {
        return this.$store.state.ppiApplication;
      },
      errorMsg() {
        return this.$store.state.ppiApplication.errorMsg;
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/ppi-application-amba' || first === '/portal/ppi-application-amba/' || this.ppiApplication.customer.partnerName === 'Mercer'){
          return 'Mercer';
        }else if (first === '/portal/ppi-application-realshield' || first === '/portal/ppi-application-realshield/' || this.ppiApplication.customer.partnerName === 'Realshield'){
          return 'Realshield';
        }
        else if (first === '/ermunro/ppi-application/' || first === '/ERMUNRO/ppi-application/' || this.ppiApplication.customer.partnerName === 'Ermunro'){
          return 'Ermunro';
        }
        else {
          return 'OREP';
        }
      },
    },
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      hamSpin() {
        this.isActive = !this.isActive;
      }
    }
  }
</script>
